"use client";

import * as React from "react";
import SharedShellFrame, {
  RAIL_WIDTH,
  type ShellColumns,
  type ShellFrameProps as SharedShellFrameProps,
} from "@workspace/gamja-platform/components/shell-frame";

import ContentHeader from "@/components/article-shell/ContentHeader";
import IconRail from "@/components/article-shell/IconRail";

export type { ShellColumns };
export { RAIL_WIDTH };

interface ShellFrameProps
  extends Omit<SharedShellFrameProps, "rail" | "header"> {
  rail?: React.ReactNode;
  header?: React.ComponentProps<typeof ContentHeader>;
  renderHeader?: React.ReactNode;
}

/**
 * JCG 전용 어댑터.
 *
 * 셸의 DOM·컬럼·리사이즈는 공용 패키지가 소유하고, 여기서는 JCG 의 레일·헤더를
 * 기본 슬롯으로 채운다. 기존 호출부 API(`rail` 생략 시 JCG IconRail, `header` 객체 전달)를
 * 그대로 유지하므로 IndexShell·RailShell 등 소비자는 변경하지 않는다.
 */
export default function ShellFrame({
  rail,
  header,
  renderHeader,
  ...frameProps
}: ShellFrameProps) {
  return (
    <SharedShellFrame
      {...frameProps}
      rail={rail ?? <IconRail />}
      header={renderHeader ?? (header && <ContentHeader {...header} />)}
    />
  );
}
